import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

//DSS Documentation on SocoConfigurationService - http://tiny.sc/cgsococonfigurationservice
import { SocoConfigurationService } from '@soco/configuration';
//DSS Documentation on SocoModalService - http://tiny.sc/cgsocomodalservice
import { SocoModalService } from '@soco/modal';

import { Sample } from '../sample';
import { SampleAddComponent } from '../add/sample-add.component';
import { SampleEditComponent } from '../edit/sample-edit.component';
import { SampleService } from '../sample.service';
import { AuthorizationService } from '../../core/authorization.service';

@Component({
    selector: 'sample-list',
    templateUrl: 'sample-list.component.html'
})
export class SampleListComponent implements OnInit, OnDestroy {
    isLoading: boolean = true;
    samples: Sample[] = [];
    coolComplianceUrl: string = null;
    isSampleAdmin: boolean = false;

    private unsubscribe$ = new Subject<void>();

    @ViewChild(SampleAddComponent, { static: false }) sampleAddComponent: SampleAddComponent;
    @ViewChild(SampleEditComponent, { static: false }) sampleEditComponent: SampleEditComponent;

    constructor(
        private sampleService: SampleService,
        private authorizationService: AuthorizationService,
        private config: SocoConfigurationService,
        private socoModalService: SocoModalService
    ) { }

    ngOnInit(): void {
        this.getAll();

        //query the authorization service to determine if the current user is a sample admin, if they are
        //not a SampleAdmin then we will hide the Add/Edit/Delete buttons in the sample grid
        this.authorizationService.isSampleAdmin()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(isSampleAdmin => {
                this.isSampleAdmin = isSampleAdmin;
            });

        //just for demo purposes to show how we can get Settings marked as SafeForClient
        //DSS Documentation on SocoConfigurationService - http://tiny.sc/cgsococonfigurationservice
        let coolComplianceUrlSettingName = 'CoolComplianceUrl';
        this.config.getSetting<string>(coolComplianceUrlSettingName)
            //.(takeUntil(this.unsubscribe$))
            //.subscribe(coolComplianceUrl => {
            //    this.coolComplianceUrl = coolComplianceUrl;
            //    console.log(coolComplianceUrlSettingName + '=' + this.coolComplianceUrl);
            //});
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    //=============================================================================================================
    //EVENT HANDLERS
    //=============================================================================================================
    add(): void {
        this.sampleAddComponent.show();
    }

    edit(id: number): void {
        this.sampleEditComponent.show(id);
    }

    delete(sample: Sample): void {
        //DSS Documentation on SocoModalService - http://tiny.sc/cgsocomodalservice
        this.socoModalService.confirm({
            title: 'Delete?',
            body: 'Are you sure you want to delete the sample?',
            dontCloseOnChoice: true,
            confirmationCallback: (confirmed: boolean) => {
                if (confirmed) {
                    this.del(sample.id);
                }
                else {
                    this.socoModalService.hide();
                }
            }
        });
    }

    sampleAddClosed(): void {
        this.getAll();
    }

    sampleEditClosed(): void {
        this.getAll();
    }

    //=============================================================================================================
    //WEB METHODS
    //=============================================================================================================
    private getAll(): void {
        this.isLoading = true;
        this.sampleService.getAll().subscribe(result => {
            this.isLoading = false;
            this.samples = result.data;
        });
    }

    private del(id: number): void {
        this.sampleService.del(id).subscribe(result => {
            //DSS Documentation on SocoModalService - http://tiny.sc/cgsocomodalservice
            this.socoModalService.hide();
            this.getAll();
        });
    }
}
